import $http from '@/libs/axios'

export default class RegisterTerminalAPI {
  static async create(terminal: any) {
    return (await $http.post('/pos/terminals', terminal)).data?.data
  }

  static async update(terminalId: number, terminal: any) {
    return (await $http.put(`/pos/terminals/${terminalId}`, terminal)).data?.data
  }

  static async remove(terminalId: number) {
    return (await $http.delete(`/pos/terminals/${terminalId}`)).data
  }

  static async getTerminalsList(branchId: number) {
    return (await $http.get(`/pos/terminals/list/${branchId}?filter=true`)).data
  }

  static async deactivate(terminalId: number) {
    return (await $http.put(`/pos/terminals/${terminalId}/deactivate`)).data
  }
}
